import { render, staticRenderFns } from "./X-livraison-datatable.vue?vue&type=template&id=a95d3e56&scoped=true"
import script from "./X-livraison-datatable.vue?vue&type=script&lang=js"
export * from "./X-livraison-datatable.vue?vue&type=script&lang=js"
import style0 from "./X-livraison-datatable.vue?vue&type=style&index=0&id=a95d3e56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95d3e56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a95d3e56')) {
      api.createRecord('a95d3e56', component.options)
    } else {
      api.reload('a95d3e56', component.options)
    }
    module.hot.accept("./X-livraison-datatable.vue?vue&type=template&id=a95d3e56&scoped=true", function () {
      api.rerender('a95d3e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/X-livraison-datatable.vue"
export default component.exports